"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exponentialBackoff = exports.getInternalLocale = exports.privaliaSuffix = exports.i18nBase = exports.fillParams = exports.parseKey = void 0;
const REGEX = /\${(\w+)}/g;
const parseKey = (key) => {
    const keys = {};
    const matches = key.match(REGEX);
    if (!matches)
        return {};
    matches.forEach((item) => (keys[item.replace(REGEX, '$1')] = ''));
    return keys;
};
exports.parseKey = parseKey;
const fillParams = (template, value = {}) => {
    const keys = (0, exports.parseKey)(template);
    const names = Object.keys(Object.assign(Object.assign({}, keys), value));
    const values = Object.values(Object.assign(Object.assign({}, keys), value));
    try {
        return Function(...names, `return \`${template}\`;`)(...values);
    }
    catch (_a) {
        return template;
    }
};
exports.fillParams = fillParams;
const i18nBase = (translations) => (search, params) => {
    if (!translations || !translations[search])
        return search;
    return (0, exports.fillParams)(translations[search], params);
};
exports.i18nBase = i18nBase;
const privaliaSuffix = (isPrivalia) => (isPrivalia ? '-priv' : '');
exports.privaliaSuffix = privaliaSuffix;
const getInternalLocale = (locale, isPrivalia) => locale && `${locale}${(0, exports.privaliaSuffix)(isPrivalia)}`;
exports.getInternalLocale = getInternalLocale;
const exponentialBackoff = (promise, retries = 5, delay = 200) => promise().catch((error) => {
    if (!retries)
        return Promise.reject(error);
    const next = () => (0, exports.exponentialBackoff)(promise, retries - 1, delay * 2);
    return new Promise((resolve) => setTimeout(() => resolve(next()), delay));
});
exports.exponentialBackoff = exponentialBackoff;
